export const APP_NAME = 'Dreamwrite'
export const APP_CONSOLE_NAME = `${APP_NAME} Console`
export const APP_AGENT_API_GUIDE_TITLE = `${APP_NAME} Agent API Guide`
export const APP_API_SERVICE_NAME = `${APP_NAME} API`
